import React from "react";
import { products } from "../mock";
import { Link } from "react-router-dom";

export default function Prodotti() {
  return (
    <div className="w-full pt-32 pb-24 px-6 lg:px-12 bg-white min-h-screen">
      <div className="container mx-auto">
        <h1 className="text-5xl md:text-8xl font-bold tracking-tighter mb-12 uppercase max-w-5xl mx-auto">
          I Nostri Prodotti
        </h1>
        
        <p className="text-xl text-gray-500 font-light max-w-3xl mb-24 mx-auto text-center md:text-left">
          Dal PVC all'Alluminio, offriamo soluzioni personalizzate per ogni esigenza architettonica.
          Finestre, scorrevoli e porte progettate per durare nel tempo, garantendo isolamento termico e acustico.
        </p>

        <div className="flex flex-col gap-32 max-w-6xl mx-auto">
          {products.map((prod, index) => (
            <div 
              key={prod.id} 
              className={`flex flex-col md:flex-row gap-12 items-center ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
            >
              <div className="w-full md:w-1/2 aspect-[4/3] bg-gray-100 overflow-hidden">
                <img 
                  src={prod.image} 
                  alt={prod.title} 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="w-full md:w-1/2 flex flex-col justify-center space-y-6 px-4 md:px-12">
                <div className="text-sm font-bold uppercase tracking-widest text-gray-400">Sistema 0{index + 1}</div>
                <h2 className="text-4xl md:text-6xl font-bold tracking-tighter">{prod.title}</h2>
                <p className="text-xl font-light text-gray-600 leading-relaxed">
                  {prod.description}
                </p>
                <div className="pt-4 flex flex-col sm:flex-row gap-6">
                  <Link to={`/prodotti/${prod.slug}`} className="inline-block border-b border-black pb-1 text-sm font-bold uppercase tracking-widest hover:text-[#7dba00] hover:border-[#7dba00] transition-colors cursor-pointer w-fit">
                    Scopri di più
                  </Link>
                  <Link to="/contatti" className="inline-block border-b border-gray-300 text-gray-500 pb-1 text-sm font-bold uppercase tracking-widest hover:text-[#7dba00] hover:border-[#7dba00] transition-colors cursor-pointer w-fit">
                    Richiedi Preventivo
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
